import Fire from '../config/Fire';
import {
	MATCH_SQUAD_FETCH,
	MATCH_SQUAD_FETCH_SUCCESS,
	MATCH_SQUAD_FETCH_FAIL,
	MATCH_SQUAD_TOGGLE_EDIT,
	MATCH_SQUAD_RATING_CHANGE,
	MATCH_SQUAD_AVG_RATING_CHANGE,
	MATCH_SQUAD_UPDATE_SUCCESS,
	MATCH_SQUAD_UPDATE_FAIL,
	MATCH_SQUAD_REVIEW_CHANGE,
	MATCH_SQUAD_GOAL_CHANGE,
	MATCH_SQUAD_CARD_CHANGE,
	MATCH_SQUAD_POSITION_CHANGE,
	MATCH_SQUAD_ADD_PLAYER,
	MATCH_SQUAD_ADD_PLAYER_SUCCESS,
	MATCH_SQUAD_ADD_PLAYER_FAIL,
	MATCH_SQUAD_DELETE_PLAYER,
	MATCH_SQUAD_DELETE_PLAYER_SUCCESS,
	MATCH_SQUAD_DELETE_PLAYER_FAIL,
	MATCH_SQUAD_INPUT_PLAYER,
	MATCH_SQUAD_INPUT_POSITION,
	MATCH_SQUAD_INPUT_GOAL,
	MATCH_SQUAD_INPUT_CARD,
	MATCH_SQUAD_INPUT_MATCH_RATING,
	MATCH_SQUAD_INPUT_REVIEW,
} from './types';

export const matchSquadFetch = doc => {
	return dispatch => {
		dispatch({ type: MATCH_SQUAD_FETCH });
		Fire.firestore()
			.collection('matchSquads')
			.doc(doc)
			.collection('squad')
			.get()
			.then(function(querySnapshot) {
				const obj = {};
				querySnapshot.forEach(function(doc) {
					let v = {};
					v = doc.data();
					v.readOnly = true;
					v.userVoted = false;
					v.onChange = { ...doc.data(), playerDoc: doc.id };
					v.playerDoc = doc.id;
					obj[doc.data().position] = v;
				});
				return dispatch({
					type: MATCH_SQUAD_FETCH_SUCCESS,
					id: parseInt(doc, 10),
					payload: obj,
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				return dispatch({ type: MATCH_SQUAD_FETCH_FAIL });
			});
	};
};

export const addPlayerMatchSquad = (doc, pDoc, obj) => {
	return dispatch => {
		dispatch({ type: MATCH_SQUAD_ADD_PLAYER });
		Fire.firestore()
			.collection('matchSquads')
			.doc(doc)
			.collection('squad')
			.doc(pDoc)
			.set(obj, { merge: true })
			.then(function() {
				let v = {};
				let objNew = {};
				v = obj;
				v.readOnly = true;
				v.onChange = { ...obj, playerDoc: pDoc };
				v.playerDoc = pDoc;
				objNew[obj.position] = v;
				return dispatch({
					type: MATCH_SQUAD_ADD_PLAYER_SUCCESS,
					payload: objNew,
					id: parseInt(doc, 10),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				return dispatch({ type: MATCH_SQUAD_ADD_PLAYER_FAIL });
			});
	};
};

export const deletePlayerMatchSquad = (doc, pDoc) => {
	return dispatch => {
		dispatch({ type: MATCH_SQUAD_DELETE_PLAYER });
		Fire.firestore()
			.collection('matchSquads')
			.doc(doc)
			.collection('squad')
			.doc(pDoc)
			.delete()
			.then(function() {
				return dispatch({
					type: MATCH_SQUAD_DELETE_PLAYER_SUCCESS,
					payload: pDoc,
					id: parseInt(doc, 10),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				return dispatch({ type: MATCH_SQUAD_DELETE_PLAYER_FAIL });
			});
	};
};

export const toggleEdit = (i, pos) => ({
	type: MATCH_SQUAD_TOGGLE_EDIT,
	id: i,
	payload: pos,
});

export const onReviewChange = (i, t, obj) => ({
	type: MATCH_SQUAD_REVIEW_CHANGE,
	id: i,
	payload: { position: obj.position, text: t },
});

export const onGoalsChange = (i, v, obj) => ({
	type: MATCH_SQUAD_GOAL_CHANGE,
	id: i,
	payload: { position: obj.position, value: parseInt(v, 10) },
});

export const onCardsChange = (i, v, obj) => ({
	type: MATCH_SQUAD_CARD_CHANGE,
	id: i,
	payload: { position: obj.position, value: v },
});

export const onPositionChange = (i, v, obj) => ({
	type: MATCH_SQUAD_POSITION_CHANGE,
	id: i,
	payload: { position: obj.position, value: v },
});

export const onRatingChange = (i, v, obj) => ({
	type: MATCH_SQUAD_RATING_CHANGE,
	id: i,
	payload: { position: obj.position, value: v },
});

export const onAvgRatingChange = (i, obj) => ({
	type: MATCH_SQUAD_AVG_RATING_CHANGE,
	id: i,
	payload: obj,
});

export const inputPlayerChange = v => ({
	type: MATCH_SQUAD_INPUT_PLAYER,
	payload: v,
});

export const inputPositionChange = v => ({
	type: MATCH_SQUAD_INPUT_POSITION,
	payload: v,
});

export const inputGoalChange = v => ({
	type: MATCH_SQUAD_INPUT_GOAL,
	payload: v,
});

export const inputCardChange = v => ({
	type: MATCH_SQUAD_INPUT_CARD,
	payload: v,
});

export const inputMatchRatingChange = v => ({
	type: MATCH_SQUAD_INPUT_MATCH_RATING,
	payload: v,
});

export const inputMatchReviewChange = v => ({
	type: MATCH_SQUAD_INPUT_REVIEW,
	payload: v,
});

export const matchSquadUpdate = (i, obj) => {
	return dispatch => {
		Fire.firestore()
			.collection('matchSquads')
			.doc(i.toString())
			.collection('squad')
			.doc(obj.playerDoc)
			.set(obj, { merge: true })
			.then(function() {
				return dispatch({
					type: MATCH_SQUAD_UPDATE_SUCCESS,
					payload: obj,
					id: parseInt(i, 10),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				dispatch({
					type: MATCH_SQUAD_UPDATE_FAIL,
					id: i,
					error: true,
					errorText: _err.message,
				});
				setTimeout(function() {
					return dispatch({
						type: MATCH_SQUAD_UPDATE_FAIL,
						id: i,
						error: false,
						errorText: '',
					});
				}, 1500);
			});
	};
};

export default { toggleEdit, matchSquadUpdate, onReviewChange, onAvgRatingChange };



// WEBPACK FOOTER //
// ./src/actions/MatchSquadActions.js